module.exports = __webpack_public_path__ + "img/mortar_symbol_blue.f688d8fc.svg";